import React from "react";

const IconCloseSvg = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="32" height="32" rx="16" fill="#F4F6F9" fillOpacity="0.05" />
    <path
      d="M20.4426 9.43945C21.0284 8.85367 21.9789 8.85367 22.5647 9.43945C23.1502 10.0252 23.1502 10.9748 22.5647 11.5605L18.1233 16.002L22.5647 20.4434C23.15 21.0292 23.1503 21.9788 22.5647 22.5645C21.9791 23.1501 21.0294 23.1498 20.4436 22.5645L16.0022 18.123L11.5608 22.5645C10.9751 23.1499 10.0254 23.1499 9.4397 22.5645C8.85399 21.9787 8.85416 21.0292 9.4397 20.4434L13.8801 16.001L9.4397 11.5605C8.85391 10.9748 8.85391 10.0252 9.4397 9.43945C10.0255 8.85367 10.975 8.85367 11.5608 9.43945L16.0012 13.8799L20.4426 9.43945Z"
      fill="#CBD1DC"
    />
  </svg>
);

export default IconCloseSvg;
